import {
  createStore,
  applyMiddleware,
  compose,
  bindActionCreators,
} from "redux";
import { connect } from "react-redux";
import createSagaMiddleware, { END } from "redux-saga";
import { createLogger } from "redux-logger";
import rootReducers from "./reducers";
import rootSagas from "./sagas";

export function connectAutoDispatch(mapStateToProps, actions, ...args) {
  return connect(
    mapStateToProps,
    (dispatch) => bindActionCreators(actions, dispatch),
    ...args
  );
}

const configureStore = (initialState) => {
  const sagaMiddleware = createSagaMiddleware();
  const loggerMiddleWare = createLogger();
  const m = [sagaMiddleware];
  if (process.env.NODE_ENV === "development") {
    m.push(loggerMiddleWare);
  }
  const middlewares = applyMiddleware(...m);
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  const enhancer = composeEnhancers(middlewares);
  const store = createStore(rootReducers, initialState, enhancer);

  sagaMiddleware.run(rootSagas);

  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);

  return store;
};

export default configureStore;
